export default __webpack_public_path__ + "static/viraj-201d030ebb17d52224be20ce80a5c4e0.svg";